/*!
  Brava, by Koding Themes
  predictive-search.js
  https://kodingthemes.com
*/

class PredictiveSearch extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector('input[type="search"]');
		this.predictiveSearchResults = this.querySelector('#predictive-search');
		this.input.addEventListener('input', this.debounce((event) => {
			this.onChange(event);
		}, 300).bind(this));
		this.input.addEventListener('focus', this.debounce((event) => {
			this.onFocus(event);
		}, 0).bind(this));
	}
	onChange() {
		const searchTerm = this.input.value.trim();
		if (!searchTerm.length) {
			this.close();
			document.querySelector('.overlay-search').classList.remove('show-overlay')
			document.querySelector('.overlay-search').classList.remove('header-search__overlay')
			return;
		}
		document.querySelector('.overlay-search').classList.add('show-overlay')
		document.querySelector('.overlay-search').classList.add('header-search__overlay')
		this.getSearchResults(searchTerm);
	}
	onFocus() {
		const searchTerm = this.input.value.trim();
		if (!searchTerm.length) {
			this.close();
			document.querySelector('.overlay-search').classList.remove('show-overlay')
			document.querySelector('.overlay-search').classList.remove('header-search__overlay')
			return;
		}
		document.querySelector('.overlay-search').classList.add('show-overlay')
		document.querySelector('.overlay-search').classList.add('header-search__overlay');
		this.getSearchResults(searchTerm);
	}
	getSearchResults(searchTerm) {
		fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`).then((response) => {
			if (!response.ok) {
				var error = new Error(response.status);
				this.close();
				throw error;
			}
			return response.text();
		}).then((text) => {
			const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
			this.predictiveSearchResults.innerHTML = resultsMarkup;
			this.open();
		}).catch((error) => {
			this.close();
			throw error;
		});
	}
	open() {
		this.predictiveSearchResults.style.display = 'block';
		this.predictiveSearchResults.classList.add('show-results');
	}
	close() {
		this.predictiveSearchResults.style.display = 'none';
		this.predictiveSearchResults.classList.remove('show-results');
		this.predictiveSearchResults.innerHTML = '';
	}
	debounce(fn, wait) {
		let t;
		return (...args) => {
			clearTimeout(t);
			t = setTimeout(() => fn.apply(this, args), wait);
		};
	}
}
customElements.define('predictive-search', PredictiveSearch);
var forms = document.querySelectorAll('predictive-search');
var searchForm = document.querySelector('.search-form__input');
var overlay = document.querySelector('.overlay-search');
var _body = document.body;
document.body.addEventListener('click', function(e) {
	var target = e.target;
	if (e.target.classList[0] === searchForm.classList[0]) {
		overlay.classList.add('show-overlay');
		overlay.classList.add('header-search__overlay');
		console.log('target', target.classList);
	} else {
		overlay.classList.remove('show-overlay');
		overlay.classList.remove('header-search__overlay');
	}
	if (forms != null) {
		forms.forEach(function(form, index) {
			if (target.closest('predictive-search') == null) {
				forms.forEach(function(form, index) {
					var list = form.querySelector('.header-search__results');
					if (list != null) {
						list.style.display = 'none';
					}
				});
			}
			var input = form.querySelector('input[type="search"]');
			if (target == input) {
				forms.forEach(function(form, index) {
					var list = form.querySelector('.header-search__results');
					if (list != null) {
						list.style.display = 'none';
					}
				});
				var list = form.querySelector('.header-search__results');
				if (list.innerHTML != '') {
					list.style.display = 'block';
				}
			}
		});
	}
});
